import { BrowserRouter } from 'react-router-dom'
import { AuthInitializer } from './components/auth/AuthInitializer'
import { AppRouter } from './router'

export default function App() {
  return (
    <BrowserRouter>
      <AuthInitializer>
        <AppRouter />
      </AuthInitializer>
    </BrowserRouter>
  )
}
